import en from "./en";
import zh_cn from "./zh_cn";
import zh_tw from "./zh_tw";
import ja_kanji from "./ja_kanji";

export const ParentTranslations = {
  ja_kanji: ja_kanji,
  en: en,
  zh_cn: zh_cn,
  zh_tw: zh_tw,
};
